var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex h-[100vh] items-center justify-center"},[_c('h1',[_vm._v(" Redirect to Mitra Komerce Mobile App ")])])}]

export { render, staticRenderFns }